import { Box, Stack, styled, SxProps, Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

import { ReactComponent as CzechFlag } from '../../assets/czech-flag.svg'
import { ReactComponent as HungaryFlag } from '../../assets/hungary-flag.svg'
import { ReactComponent as SkFlag } from '../../assets/sk-flag.svg'
import { ReactComponent as SpainFlag } from '../../assets/spain-flag.svg'

interface IProps {
  sx?: SxProps
  project: 'arbipay' | 'arbipoint'
}

const SvgWrapper = styled('div')({
  width: '60px',
  height: '45px',
  '& svg': { width: '60px', height: '45px', display: 'block' },
})

export const PlanetExpansion = ({ sx, project }: IProps) => {
  const { t } = useTranslation('widgets')

  return (
    <Box sx={sx}>
      <Stack
        minHeight={170}
        direction={{ xs: 'column', md: 'row' }}
        gap={{ xs: 2.5, md: 8 }}
        flexWrap={{ xs: 'nowrap', md: 'wrap', lg: 'nowrap' }}
        alignItems={{ xs: 'flex-start', md: 'flex-end' }}
        justifyContent={{ xs: 'flex-start', md: 'space-between' }}
      >
        <Stack
          flex={{ xs: '1 1 100%', md: '1 1 100%', lg: '0 0 auto' }}
          width={{ xs: '100%', md: '100%', lg: 'auto' }}
          maxWidth={{ lg: '360px' }}
          alignSelf={'flex-start'}
        >
          <Typography variant="subtitle25SemiBold">
            {t(`main-page.projects.${project}.planned-expansion.title`)}
          </Typography>

          <Typography mt={{ xs: 1, md: 2.5 }} variant="text18Regular">
            {t(`main-page.projects.${project}.planned-expansion.text`)}
          </Typography>
        </Stack>

        <Stack
          flex={1}
          width={{ xs: '100%', md: 'auto' }}
          gap={2.5}
          alignSelf={'flex-end'}
        >
          <Stack direction="row" gap={2.5}>
            <SvgWrapper>
              <SkFlag style={{ minWidth: 38 }} />
            </SvgWrapper>

            <Stack>
              <Typography variant="text18Medium">
                <Trans
                  t={t}
                  i18nKey={`main-page.projects.${project}.planned-expansion.list.0.title`}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Typography>

              <Typography
                variant="subtitle14Up"
                sx={{
                  textWrap: {
                    xs: 'wrap',
                    md: project === 'arbipoint' ? 'nowrap' : 'wrap',
                  },
                }}
              >
                <Trans
                  t={t}
                  i18nKey={`main-page.projects.${project}.planned-expansion.list.0.description`}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Typography>
            </Stack>
          </Stack>

          <Stack direction="row" gap={2.5}>
            <SvgWrapper>
              <SpainFlag />
            </SvgWrapper>

            <Stack>
              <Typography variant="text18Medium">
                <Trans
                  t={t}
                  i18nKey={`main-page.projects.${project}.planned-expansion.list.1.title`}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Typography>

              <Typography
                variant="subtitle14Up"
                sx={{
                  textWrap: {
                    xs: 'wrap',
                    md: project === 'arbipoint' ? 'nowrap' : 'wrap',
                  },
                }}
              >
                <Trans
                  t={t}
                  i18nKey={`main-page.projects.${project}.planned-expansion.list.1.description`}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        <Stack
          flex={1}
          width={{ xs: '100%', md: 'auto' }}
          gap={2.5}
          alignSelf={'flex-end'}
        >
          <Stack direction="row" gap={2.5}>
            <SvgWrapper>
              <HungaryFlag />
            </SvgWrapper>

            <Stack>
              <Typography variant="text18Medium">
                <Trans
                  t={t}
                  i18nKey={`main-page.projects.${project}.planned-expansion.list.2.title`}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Typography>

              <Typography
                variant="subtitle14Up"
                sx={{
                  textWrap: {
                    xs: 'wrap',
                    md: project === 'arbipoint' ? 'nowrap' : 'wrap',
                  },
                }}
              >
                <Trans
                  t={t}
                  i18nKey={`main-page.projects.${project}.planned-expansion.list.2.description`}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Typography>
            </Stack>
          </Stack>

          <Stack direction="row" gap={2.5}>
            <SvgWrapper>
              <CzechFlag />
            </SvgWrapper>

            <Stack>
              <Typography variant="text18Medium">
                <Trans
                  t={t}
                  i18nKey={`main-page.projects.${project}.planned-expansion.list.3.title`}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Typography>

              <Typography
                variant="subtitle14Up"
                sx={{
                  textWrap: {
                    xs: 'wrap',
                    md: project === 'arbipoint' ? 'nowrap' : 'wrap',
                  },
                }}
              >
                <Trans
                  t={t}
                  i18nKey={`main-page.projects.${project}.planned-expansion.list.3.description`}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}
